import { set } from "lodash";

const FiltersHelper = {
  buildRequestFilters(filter: any): any {
    const f = {};

    Object.keys(filter).forEach((key) => {
      const normalizedKey = key.replace(/[A-Z]/g, (m) => "_" + m.toLowerCase());
      if (filter[key].length > 0) {
        set(f, normalizedKey, filter[key].join(","));
      } else {
        set(f, normalizedKey, filter[key]);
      }
    });

    return f;
  },
};

export default FiltersHelper;
